import defaultRoutes from '../enums/defaultRoutes';

export const filterDriverRoutes = (routes) =>
  Object.values(routes).filter(
    (route) =>
      (!route.defaultRoute && !route.sectionRoute) ||
      (route.defaultRoute &&
        !defaultRoutes[route.routeCode] &&
        !route.sectionRoute)
  );

export const findSectionRoute = (routes, sectionId) =>
  Object.values(routes).find(
    ({ defaultRoute, sectionRoute, sectionCode }) =>
      defaultRoute && sectionRoute && sectionCode === sectionId
  );

export const filterDefaultRoutes = (routes, sectionId) =>
  Object.values(routes).filter(
    ({ defaultRoute, routeCode, sectionRoute, sectionCode }) =>
      defaultRoute &&
      defaultRoutes[routeCode] &&
      (!sectionRoute || sectionCode !== sectionId)
  );
